import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../Services/LoginService';

@Component({
  selector: 'ManagementFooter',
  templateUrl: './ManagementFooter.html?v=${new Date().toISOString()}',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css']

})
export class ManagementFooter implements OnInit {
  UserName: string = "";
  showfooter: string = "hidden";
  // Punchout: any = "../../Content/images/PunchOut.gif";
  constructor(private route: ActivatedRoute, private router: Router, private _LoginService: LoginService) {

  }
  ngOnInit() {
    this.UserName = sessionStorage.getItem('UserName');
  }

  Logout() {
    // Server-side SignOutAsync invalidates the HttpOnly auth cookie.
    // HttpOnly cookies cannot be deleted via JS, so deleteAllCookies() is no longer called.
    this._LoginService.logout().subscribe(() => {
      sessionStorage.clear();
      localStorage.clear();
      this.router.navigate(['/Login']);
    });
  }

  footerclick(val: string) {
    if (val == "In") {
      this.showfooter = "visible";
    }
    else { this.showfooter = "hidden"; }
  }

  // deleteAllCookies() is commented out: HttpOnly cookies cannot be deleted via JavaScript.
  // The server-side SignOutAsync call in Logout() handles auth cookie invalidation.
  // deleteAllCookies() {
  //   var cookies = document.cookie.split(";");
  //   for (var i = 0; i < cookies.length; i++) {
  //     var cookie = cookies[i];
  //     var eqPos = cookie.indexOf("=");
  //     var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
  //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/Shared/ManagementFooter.ts